import React, { Component, useEffect, useRef } from "react";
import styles from "./Guide.module.css";

function Guide() {
  const borderEl = useRef(null);
  const guideList = [
    { id: 0, name: "نرم افزار ها", elementId: "homePage-Softwares__sec" },
    { id: 1, name: "تعرفه ها", elementId: "homePage-pricing__sec" },
    { id: 2, name: "ویدیو ها", elementId: "homePage-Contents__sec" },
    { id: 3, name: "محصولات", elementId: "homePage-products__sec" },
    // { id: 4, name: "مطالب", elementId: "homePage-blogs__sec" },
    { id: 5, name: "مشتری ها", elementId: "homePage-customers__sec" },
  ];
  function handleClick(e) {
    const elementId = e.target.closest("li").dataset.elementid;
    document
      .querySelector(`#${elementId}`)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }

  useEffect(() => {
    const interval = setInterval(() => {
      borderEl.current.classList.toggle(`${styles.isUndrawn}`);
      borderEl.current.classList.toggle(`${styles.isDrawn}`);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className={`${styles.guideCont}`}>
        <div
          className={`${styles.guide} ${styles.isDrawn}`}
          id="drowing-border"
          ref={borderEl}>
          <ul className={`${styles.guideUl}`}>
            {guideList.map((e) => {
              return (
                <li
                  key={e.id}
                  className={`${styles.guideLi}`}
                  data-elementid={e.elementId}>
                  <button onClick={handleClick}>{e.name}</button>
                </li>
              );
            })}
          </ul>
          <div className={`${styles.hintsUnderLine}`}></div>
        </div>
      </div>
    </>
  );
}

export default Guide;
